export const BASE_URL_SERVICE = "https://gestion.innovatiio.com/api/v1/";
export const BASE_URL_SERVICE_PROCESOS = "https://gestion.innovatiio.com/api/";
export const BASE_URL_SERVICE_UPLOADS = "https://gestion.innovatiio.com/api/uploads/";
export const BASE_URL_ZENDESK = "https://tutea.zendesk.com/";

export const MODO_DEV = false